<template>
  <b-container>
    <b-form>
      <b-form-group
        id="promotion-name-label"
        label="ชื่อโปรโมชั่น"
        class="text-left"
        label-for="promotion-name"
      >
        <template v-slot:label>
          ชื่อโปรโมชั่น
          <span
            class="text-danger"
          >
            *
          </span>
        </template>
        <b-form-input
          id="promotion-name"
          v-model="itemComputed.name"
        />
      </b-form-group>
      <b-form-group
        id="promotion-description-label"
        label="รายละเอียด"
        class="text-left"
        label-for="promotion-description"
      >
        <b-form-input
          id="promotion-description"
          v-model="itemComputed.description"
        />
      </b-form-group>
      <b-form-group
        id="promotion-value-label"
        label="ลดจำนวน"
        class="text-left"
        label-for="promotion-value"
      >
        <template v-slot:label>
          ลดจำนวน
          <span
            class="text-danger"
          >
            *
          </span>
        </template>
        <b-form-input
          id="promotion-value"
          v-model="itemComputed.value"
          type="number"
        />
        <b-form-radio-group
          id="promotion-discount-type-group"
          v-model="itemComputed.discount_type"
          name="promotion-discount-type"
        >
          <b-form-radio value="percent">
            เปอร์เซ็น
          </b-form-radio>
          <b-form-radio value="baht">
            บาท
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group
        id="promotion-start-date-label"
        label="วันเริ่มโปรโมชั่น"
        class="text-left"
        label-for="promotion-start-date"
      >
        <b-input-group>
          <flat-pickr
            id="promotion-start-date"
            v-model="itemComputed.start_date"
            :config="datePickerConfig"
            class="form-control"
            placeholder="คลิกเพื่อตั้งวันเริ่มโปรโมชั่น"
            name="promotion-end-date"
          />
          <b-button
            variant="danger"
            data-clear
            @click="clearItem('start_date', null)"
          >
            ล้าง
          </b-button>
        </b-input-group>
      </b-form-group>
      <b-form-group
        id="promotion-end-date-label"
        label="วันหมดโปรโมชั่น"
        class="text-left"
        label-for="promotion-end-date"
      >
        <b-input-group>
          <flat-pickr
            id="promotion-end-date"
            v-model="itemComputed.end_date"
            :config="datePickerConfig"
            class="form-control"
            placeholder="คลิกเพื่อตั้งวันหมดโปรโมชั่น"
            name="promotion-end-date"
          />
          <b-button
            variant="danger"
            data-clear
            @click="clearItem('end_date', null)"
          >
            ล้าง
          </b-button>
        </b-input-group>
      </b-form-group>
      <b-form-group
        id="promotion-type-label"
        label="รูปแบบการลดราคา"
        class="text-left"
        label-for="promotion-type"
      >
        <b-form-radio-group
          id="promotion-type"
          v-model="itemComputed.type"
          name="promotion-type"
        >
          <b-form-radio value="all">
            ลดทั้งรายการ
          </b-form-radio>
          <b-form-radio value="each">
            ลดเฉพาะผลตรวจ
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <div
        v-if="itemComputed.type === 'each'"
        class="text-left my-4"
      >
        <b-row>
          <b-col
            cols="auto"
          >
            <test-selected-modal
              :choose-item-handler="chooseItemHandler"
            />
          </b-col>
          <b-col
            cols="auto"
            class="my-auto"
          >
            <span v-if="itemComputed.test_id || itemComputed.set_test_id">
              เลือกลดราคาให้กับ :  <b-badge variant="success">{{ itemComputed.product_name }}</b-badge>
            </span>
          </b-col>
        </b-row>
      </div>
      <b-form-group
        id="promotion-active-label"
        class="text-left"
        label-for="promotion-active"
      >
        <b-form-checkbox
          id="promotion-active"
          v-model="itemComputed.active"
          :value="true"
          :unchecked-value="false"
          switch
        >
          ใช้งาน
        </b-form-checkbox>
      </b-form-group>
      <div class="text-left">
        <b-button
          variant="success"
          @click="itemComputed.id ? updateHandler() : createHandler()"
        >
          {{ itemComputed.id ? 'บันทึก' : 'สร้าง' }}
        </b-button>
      </div>
    </b-form>
  </b-container>
</template>

<script>
  import { Thai } from 'flatpickr/dist/l10n/th.js';
  import flatpickr from 'flatpickr'
  import TestSelectedModal from "./TestSelectedModal";

  export default {
    name: "PromotionForm",
    components: {TestSelectedModal},
    props: {
      item: {
        type: Object,
        default: () => ({
          id: null,
          name: null,
          description: null,
          discount_type: 'percent', // percent, baht
          start_date: null,
          end_date: null,
          set_test_id: null,
          test_id: null,
          type: 'all', // each, all
          value: null,
          product_name: null,
          active: true,
        })
      },
      createDataHandler: {
        type: Function,
        default: () => false
      },
      updateDataHandler: {
        type: Function,
        default: () => false
      },
      backHandler: {
        type: Function,
        default: () => false
      }
    },
    data() {
      return {
        datePickerConfig: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'd M Y',
          altInput: true,
          dateFormat: 'U',
          locale: Thai, // locale for this instance only
        },
        flatpickr
      }
    },
    computed: {
      itemComputed: {
        get() {
          return this.item
        },
        set(value) {
          this.$emit('update:item', value)
        }
      }
    },
    mounted() {
      this.flatpickr = flatpickr('.flatpickr', this.datePickerConfig);
    },
    methods: {
      clearItem(key, value) {
        this.itemComputed[key] = value
      },
      chooseItemHandler(id, name, type) {
        this.itemComputed.product_name = name
        if (type === 'test') {
          this.itemComputed.test_id = id
        } else if (type === 'setTest') {
          this.itemComputed.set_test_id = id
        }
      },
      async updateHandler() {
          if (!this.item.name ) {
              return this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณากรอกชื่อโปรโมชั่น', 'error')
          }
          else if (!this.item.value) {
              return this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณากรอกจำนวนที่ลด', 'error')
          }
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.updateDataHandler(this.itemComputed.id, this.itemComputed, password)
        } else {
          return
        }

        this.flatpickr.forEach(fp => fp.clear())

        this.backHandler()
      },
      async createHandler() {

          if (!this.item.name ) {
              return this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณากรอกชื่อโปรโมชั่น', 'error')
          }
          else if (!this.item.value) {
              return this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณากรอกจำนวนที่ลด', 'error')
          }
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.createDataHandler(this.itemComputed, password)
        } else {
          return
        }

        this.flatpickr.forEach(fp => fp.clear())
        this.backHandler()
      }
    }
  }
</script>

<style scoped>

</style>